import React from 'react';
import { Icon } from './Icon.js';
export const IconPaperPlane4Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "m11.142,4.595L2.54.179C1.977-.112,1.32-.044.827.352.334.748.128,1.374.288,1.987l.851,3.265h3.111c.414,0,.75.336.75.75s-.336.75-.75.75H1.148l-.86,3.265c-.16.612.046,1.238.539,1.634.29.233.636.352.986.352.246,0,.494-.059.727-.178l8.602-4.417c.529-.272.858-.811.858-1.406s-.329-1.134-.858-1.406Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconPaperPlane4Fill12.js.map